module.exports = __webpack_public_path__ + "static/media/recovery-book6.69fffa1a.png";